module.exports = __webpack_public_path__ + "img/quick-mc.f63ecab6.png";